import type { CaseHistoryTimelineResponse } from '@dfg/brahma-types';

export interface EntityHistoryReducerState {
  enitityData: EntityHistoryDataInfo;
}

export type EntityHistoryDataInfo = {
  [id: string]: CaseHistoryTimelineResponse;
};

export interface EntityHistoryProviderProps {
  children: React.ReactNode;
  entityHistory: EntityHistoryReducerState;
}

export enum EntityHistoryActionTypesEnum {
  updateEntityHistory = 'UPDATE_ENTITY_HISTORY',
  replaceAll = 'REPLACE_ALL'
}

export type EntityHistoryActionPayload =
  | {
      type: EntityHistoryActionTypesEnum.updateEntityHistory;
      payload: {
        entityId: string;
        data: CaseHistoryTimelineResponse;
      };
    }
  | {
      type: EntityHistoryActionTypesEnum.replaceAll;
      payload: EntityHistoryReducerState;
    };
